import * as d3 from 'd3';

export default (container) => {
  if (container instanceof Element) {
    return d3.select(container);
  }
  if (container instanceof d3.selection) {
    return container;
  }
  const error =
    'Container is not an Element or D3 selection, or different instances of D3 are being used';
  throw new Error(error);
};
